import React from "react";
import Overview from "./Overview";
import { NewsletterProvider } from "../../context/NewsletterContext";

export const Newsletter = () => {
  return (
    <NewsletterProvider>
      <Overview />
    </NewsletterProvider>
  );
};
